import { render, staticRenderFns } from "./subprogram-nba-school-team-page.vue?vue&type=template&id=e4f0acb0&scoped=true&"
import script from "./subprogram-nba-school-team-page.vue?vue&type=script&lang=js&"
export * from "./subprogram-nba-school-team-page.vue?vue&type=script&lang=js&"
import style0 from "./subprogram-nba-school-team-page.vue?vue&type=style&index=0&id=e4f0acb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4f0acb0",
  null
  
)

export default component.exports